exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hamburger[data-v-4e6f274c] {\n  display: inline-block;\n  vertical-align: middle;\n  width: 20px;\n  height: 20px;\n  background-color: rgba(255, 255, 255, 0.647058823529412);\n}\n.hamburger.is-active[data-v-4e6f274c] {\n  transform: rotate(180deg);\n}\n", ""]);

// exports
